import { Table } from "antd";
import React from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { DecimalUtils, formatWithThousandsSeparator } from "../../../../../../libs/utils";
import type { BreakdownFormValues } from "./types";

type BreakdownSummaryRowProps = {
  hasValidTorType?: boolean;
};

const emphasisRowStyle: React.CSSProperties = {
  background: "var(--gray-200)",
  fontSize: 14,
  fontWeight: 600,
};

export const BreakdownSummaryRow = (props: BreakdownSummaryRowProps) => {
  const { hasValidTorType } = props;

  const { control } = useFormContext<BreakdownFormValues>();
  const watchedRows = useWatch({ control, name: "rows" });

  const totalBaseRent = DecimalUtils.add(watchedRows.map((row) => row.baseRent));
  const totalVat = DecimalUtils.add(watchedRows.map((row) => DecimalUtils.multiply(row.baseRent, row._vatRate)));
  const grandTotalWithVat = DecimalUtils.add([totalBaseRent, totalVat]);

  return (
    <Table.Summary.Row style={{ ...emphasisRowStyle, height: 52 }}>
      <Table.Summary.Cell index={0} colSpan={2}>
        Total
      </Table.Summary.Cell>
      <Table.Summary.Cell index={1} align="right">
        {formatWithThousandsSeparator(totalBaseRent)}
      </Table.Summary.Cell>
      <Table.Summary.Cell index={2} align="right">
        {formatWithThousandsSeparator(totalVat)}
      </Table.Summary.Cell>
      <Table.Summary.Cell index={3} align="right">
        {formatWithThousandsSeparator(grandTotalWithVat)}
      </Table.Summary.Cell>
      <Table.Summary.Cell index={4} />
      {hasValidTorType && <Table.Summary.Cell index={5} />}
    </Table.Summary.Row>
  );
};
